import CryptoJS from "crypto-js";

const privateKey = process.env.NEXT_PUBLIC_PRIVATEKEY;

export const setLocalStorage = (key, value) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

export const setExpLocalStorage = (key, data, expiresInMs) => {
  if (typeof window !== 'undefined') {
    const item = {
      data,
      expiresAt: Date.now() + (expiresInMs* 60 * 60 * 1000) 
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
};

export const getExpLocalStorage = (key) => {
  if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      const item = JSON.parse(raw);
      if (item?.expiresAt && Date.now() > item.expiresAt) {
        localStorage.removeItem(key);
        return null;
      }
      return item?.data ?? null;
    } catch {
      return null;
    }
  }
  return null;
};




export const getLocalStorage = (key)=> {
  if (typeof window !== 'undefined') {
    const value = localStorage.getItem(key);
    if (value) {
      try {
        return JSON.parse(value)
      } catch {
        return null;
      }
    }
  }
  return null;
};

export const getEncryptLocalStorage = (key)=> {
  if (typeof window !== 'undefined') {
    const value = localStorage.getItem(key);
    if (value) {
      try {
        const endata = JSON.parse(value).value
        const decrpyt = CryptoJS.AES.decrypt(endata, privateKey);
        const decrypted = decrpyt.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decrypted);
      } catch {
        return null;
      }
    }
  }
  return null;
};

export const removeLocalStorage = (key) => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(key);
  }
  return null;
}